import { createContext, useEffect, useState } from "react";

export const AluminiReportContentContext = createContext();

const initialReportContentState = {
  AluminiAssociationActivities: "",
};

export const ALUMINI_ASSOCIATION_ACTIVITIES = "AluminiAssociationActivities";

export const AluminiAssociationReportContentContextProvider = ({ children }) => {
  const [content, setContent] = useState(initialReportContentState);

  const setSubTitle = (subTitle, subTitleContent) => {
    setContent((content) => {
      const newContent = {
        ...content,
      };
      newContent[subTitle] = subTitleContent;
      return newContent;
    });
  };

  const getSubTitle = (subTitle) => {
    return content[subTitle];
  };

  useEffect(() => {
    // Get the content from the backend and use setContent to set the same
    console.log(content);
  }, [content]);

  return (
    <AluminiReportContentContext.Provider
      value={{ content, setContent, setSubTitle, getSubTitle }}
    >
      {children}
    </AluminiReportContentContext.Provider>
  );
};
